import { trigger } from "@angular/animations";
import { HttpErrorResponse } from "@angular/common/http";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { Logon } from "@serasa/core/modules/users/interfaces/logon.interface";
import { loadLogonsList, loadToggleSidenav } from "@serasa/core/modules/users/state/actions/user.actions";
import { selectLogon } from "@serasa/core/modules/users/state/selectors/user.selectors";
import { fadeIn } from "@serasa/shared/animations/fadeIn";
import { SedsSizeOptions } from "@serasa/shared/seds"; // NOSONAR
import { forkJoin, from, Observable, Subscription } from "rxjs";

import { loadDeleteUser, loadResetErrorDeleteUser } from "../../state/actions/dashboard.actions";
import { selectErrorDeleteUser, selectSuccessDeleteUser } from "../../state/selectors/dashboard.selector";

@Component({
    selector: "pl-delete-user",
    templateUrl: "./delete-user.component.html",
    styleUrls: ["./delete-user.component.scss", "../../../../../styles/theme/modal.scss"],
    animations: [trigger("fadeIn", fadeIn())],
    standalone: false
})
export class DeleteUserComponent implements OnInit, OnDestroy {

  public smallButton = SedsSizeOptions.SMALL;
  public selectedLogon: Partial<Logon | undefined> = {};
  public isDeleting = false;
  public hasError = false;

  public selectedLogon$: Observable<Partial<Logon | undefined>>;
  public selectSuccessDeleteUser$: Observable<boolean | undefined>;
  public selectErrorDeleteUser$: Observable<HttpErrorResponse | null | undefined>;

  private readonly _sub: Array<Subscription> = [];

  constructor(private readonly store: Store) {
    this.selectedLogon$ = this.store.select(selectLogon);
    this.selectSuccessDeleteUser$ = this.store.select(selectSuccessDeleteUser);
    this.selectErrorDeleteUser$ = this.store.select(selectErrorDeleteUser);
  }

  ngOnInit(): void {
    this._initSelectors();
  }

  public deleteUser(): void {
    this.isDeleting = true;

    this.store.dispatch(
      loadDeleteUser({
        logon: this.selectedLogon?.logon as string,
      }),
    );
  }

  private _initSelectors(): void {
    this._sub.push(
      this.selectedLogon$.subscribe((logon) => {
        this.selectedLogon = logon;
      }),
    );

    this._sub.push(
      this.selectErrorDeleteUser$.subscribe((error) => {
        if (error) {
          this.hasError = true;
          this.isDeleting = false;
        }
      }),
    );
  }

  ngOnDestroy(): void {
    if (this.isDeleting && !this.hasError) {
      const strgMatPaginator: { offset: number, limit: number } = JSON.parse(localStorage.getItem("mat-paginator") || '{}');
      this.store.dispatch(loadLogonsList({
        offset: strgMatPaginator.offset || 0,
        limit: 20,
        isPagination: false,
      }));
    }

    this.isDeleting = false;

    const dispatch1 = from([this.store.dispatch(loadToggleSidenav({ openSidenav: false }))]);
    const dispatch2 = from([this.store.dispatch(loadResetErrorDeleteUser())]);

    forkJoin({ dispatch1, dispatch2 });

    for (const sub of this._sub) {
      sub.unsubscribe();
    }
  }

}
